module.exports = __webpack_public_path__ + "static/media/desktopSH.60fa0865.jpg";